// src/components/TopBar.jsx
import React, { useState, useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { useLocation, useNavigate } from "react-router-dom";
import { FiHome, FiChevronRight } from "react-icons/fi";
import { FaRegUser } from "react-icons/fa";
import { GoSignOut } from "react-icons/go";
import api from "../../api/axios";
import "./TopBar.css";

const TopBar = ({ onToggleSidebar }) => {
    const { keycloak } = useKeycloak();
    const navigate = useNavigate();
    const location = useLocation();
    const [projectName, setProjectName] = useState(null);
    const [scenarioName, setScenarioName] = useState(null);

    const [username, setUsername] = useState("");

    useEffect(() => {
        if (keycloak.authenticated && keycloak.tokenParsed) {
            setUsername(keycloak.tokenParsed.name);
        }
    }, [keycloak.authenticated, keycloak.tokenParsed]);

    const handleLogout = () => {
        keycloak.logout({
            redirectUri: window.location.origin,
        });
    };

    const path = location.pathname;


    useEffect(() => {
        if (!path.startsWith("/projects/")) {
            setProjectName(null);
            return;
        }

        const projectId = path.split("/")[2];

        if (!projectId) return;


        const handleProjectUpdated = () => {
            api.get(`/project/${projectId}`)
                .then(res => setProjectName(res.data.name))
                .catch(() => setProjectName(null));
        };


        // ✅ initial load
        handleProjectUpdated();



        // ✅ listen for updates
        window.addEventListener("project-updated", handleProjectUpdated);

        return () => {
            window.removeEventListener("project-updated", handleProjectUpdated);
        };



    }, [path]);

    useEffect(() => {
        if (!path.startsWith("/scenarios/")) {
            setScenarioName(null);
            return;
        }

        const scenarioId = path.split("/")[2];

        if (!scenarioId) return;


        const handleScenarioUpdated = () => {
            api.get(`/scenario/${scenarioId}`)
                .then(res => setScenarioName(res.data.name))
                .catch(() => setScenarioName(null));
        };

        handleScenarioUpdated();
        window.addEventListener("scenario-updated", handleScenarioUpdated);

        return () => {
            window.removeEventListener("scenario-updated", handleScenarioUpdated);
        };

    }, [path]);



    // ✅ Handle dynamic routes
    let sectionLabel = null;

    if (path.startsWith("/projects")) {
        sectionLabel = "Projects";
    } else if (path.startsWith("/scenarios")) {
        sectionLabel = "Scenarios";
    } else if (path.startsWith("/partslibrary")) {
        sectionLabel = "Parts Library";
    }

    return (
        <header className="top-bar" role="banner">
            {/* ✅ LEFT: BRAND */}
            <div
                className="top-bar__brand"
                role="button"
                tabIndex={0}
                onClick={() => navigate("/")}
            >
                <img
                    src="/logoEplan.png"
                    alt="Layouts"
                    className="top-bar__logo"
                />
                <span className="top-bar__title">Layouts</span>
            </div>

            {/* ✅ CENTER: BREADCRUMB */}
            <nav className="breadcrumb" aria-label="Breadcrumb">
                {sectionLabel && (
                    <>
                        <FiChevronRight className="breadcrumb-separator-icon" />

                        <span
                            className="breadcrumb-link"
                            onClick={() => navigate(`/${sectionLabel.toLowerCase().replace(" ", "")}`)}
                        >
                            {sectionLabel}
                        </span>
                    </>
                )}


                {projectName && (
                    <>
                        <FiChevronRight className="breadcrumb-separator-icon" />

                        <span className="breadcrumb-current">
                            {projectName}
                        </span>
                    </>
                )}

                {scenarioName && (
                    <>
                        <FiChevronRight className="breadcrumb-separator-icon" />

                        <span className="breadcrumb-current">
                            {scenarioName}
                        </span>
                    </>
                )}

            </nav>

            {/* ✅ RIGHT: USER + ACTIONS */}
            <div className="top-bar__right">
                {onToggleSidebar && (
                    <button
                        type="button"
                        className="top-bar__menu"
                        aria-label="Open menu"
                        onClick={onToggleSidebar}
                    >
                        ☰
                    </button>
                )}

                {keycloak.authenticated && (
                    <>
                        <span className="user-icon" title={username}>
                            <FaRegUser /> {username}
                        </span>
                        <button
                            type="button"
                            className="top-bar__logout"
                            onClick={handleLogout}
                        >
                            <GoSignOut /> Sign Out
                        </button>
                    </>
                )}
            </div>
        </header>
    );
};

export default TopBar;